import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, post, put } from "helpers/api_helper"
import {
  ADD_PRACTICAL_TRAINING_PARTICIPANT,
  CREATE_PRACTICAL_TRAINING,
  DELETE_PRACTICAL_TRAINING,
  DELETE_PRACTICAL_TRAINING_PARTICIPANT,
  GET_ALL_PRACTICAL_TRAINING,
  GET_MATCHED_PRACTICAL_CANDIDATES,
  GET_PRACTICAL_TRAINING_DETAILS,
  GET_PRACTICAL_TRAINING_PARTICIPANTS,
  GET_PROMOTION_SUGGESTIONS,
  MARK_CANDIDATE_ASSESSMENT,
  MARK_MULTIPLE_PRACTICAL_TRAINING_PARTICIPANT_ATTENDANCE,
  MARK_PRACTICAL_TRAINING_PARTICIPANT_ATTENDANCE,
  PROMOTE_SUGGESTION,
  PT_EVALUATION_QUESTIONS,
  SUBMIT_PT_EVALUATION,
  UPDATE_PRACTICAL_TRAINING,
  View_PT_EVALUATION,
} from "helpers/url_helper"

export const getAllPracticalTrainings = createAsyncThunk(
  GET_ALL_PRACTICAL_TRAINING,
  async payload => {
    const response = await post(GET_ALL_PRACTICAL_TRAINING, payload)
    return response
  }
)
export const submitPracticalTrainingEvaluation = createAsyncThunk(
  SUBMIT_PT_EVALUATION,
  async payload => {
    const response = await post(SUBMIT_PT_EVALUATION, payload)
    return response
  }
)
export const viewPracticalTrainingEvaluation = createAsyncThunk(
  View_PT_EVALUATION,
  async payload => {
    const response = await post(View_PT_EVALUATION, payload)
    return response
  }
)
export const jobPromoteSuggestion = createAsyncThunk(
  PROMOTE_SUGGESTION,
  async payload => {
    const response = await post(PROMOTE_SUGGESTION, payload)
    return response
  }
)

export const getPromoteSuggestion = createAsyncThunk(
  GET_PROMOTION_SUGGESTIONS,
  async payload => {
    const response = await post(GET_PROMOTION_SUGGESTIONS, payload)
    return response
  }
)

export const createPracticalTraining = createAsyncThunk(
  CREATE_PRACTICAL_TRAINING,
  async payload => {
    const response = await post(CREATE_PRACTICAL_TRAINING, payload)
    return response
  }
)

export const updatePracticalTraining = createAsyncThunk(
  UPDATE_PRACTICAL_TRAINING,
  async ({ selectedUuid, payload }) => {
    const response = await put(
      `${UPDATE_PRACTICAL_TRAINING}/${selectedUuid}`,
      payload
    )
    return response
  }
)

export const deletePracticalTraining = createAsyncThunk(
  DELETE_PRACTICAL_TRAINING + "DELETE",
  async uuid => {
    const response = await del(`${DELETE_PRACTICAL_TRAINING}/${uuid}`)
    return response
  }
)

// export const getTrainingMaterialList = createAsyncThunk(
//   GET_TRAINING_MATERIAL_LIST,
//   async uuid => {
//     const response = await get(GET_TRAINING_MATERIAL_LIST)
//     return response
//   }
// )
export const getMatchedPracticalCandidates = createAsyncThunk(
  GET_MATCHED_PRACTICAL_CANDIDATES,
  async payload => {
    const response = await post(GET_MATCHED_PRACTICAL_CANDIDATES, payload)
    return response
  }
)

export const getPracticalTrainingDetails = createAsyncThunk(
  GET_PRACTICAL_TRAINING_DETAILS,
  async uuid => {
    const response = await get(`${GET_PRACTICAL_TRAINING_DETAILS}/${uuid}`)
    return response
  }
)
export const getEvaluationQuestions = createAsyncThunk(
  PT_EVALUATION_QUESTIONS,
  async payload => {
    const response = await post(PT_EVALUATION_QUESTIONS, payload)
    return response
  }
)

export const getPracticalTrainingParticipants = createAsyncThunk(
  GET_PRACTICAL_TRAINING_PARTICIPANTS,
  async payload => {
    const response = await post(GET_PRACTICAL_TRAINING_PARTICIPANTS, payload)
    return response
  }
)

export const addPracticalTrainingParticipant = createAsyncThunk(
  ADD_PRACTICAL_TRAINING_PARTICIPANT,
  async payload => {
    const response = await post(ADD_PRACTICAL_TRAINING_PARTICIPANT, payload)
    return response
  }
)

export const deletePracticalTrainingParticipant = createAsyncThunk(
  DELETE_PRACTICAL_TRAINING_PARTICIPANT,
  async uuid => {
    const response = await del(
      `${DELETE_PRACTICAL_TRAINING_PARTICIPANT}/${uuid}`
    )
    return response
  }
)

export const markPracticalTrainingParticipantAttendance = createAsyncThunk(
  MARK_PRACTICAL_TRAINING_PARTICIPANT_ATTENDANCE,
  async payload => {
    const response = await post(
      MARK_PRACTICAL_TRAINING_PARTICIPANT_ATTENDANCE,
      payload
    )
    return response
  }
)

export const markMultiplePracticalTrainingParticipantAttendance =
  createAsyncThunk(
    MARK_MULTIPLE_PRACTICAL_TRAINING_PARTICIPANT_ATTENDANCE,
    async payload => {
      const response = await post(
        MARK_MULTIPLE_PRACTICAL_TRAINING_PARTICIPANT_ATTENDANCE,
        payload
      )
      return response
    }
  )

export const markCandidateAssessment = createAsyncThunk(
  MARK_CANDIDATE_ASSESSMENT,
  async payload => {
    const response = await post(MARK_CANDIDATE_ASSESSMENT, payload)
    return response
  }
)
